import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {  memo , useRef , useEffect , forwardRef, useImperativeHandle} from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useAudio }  from "../../hooks/useAudio.ts";

const MapCardAudioGuide = forwardRef((props ,ref) => {
    // 親（画面コンポーネント）に公開する関数
    useImperativeHandle(ref, () => ({
        isPlayingSound
    }));

    const {row , resetMarker } = props;
    const { t } = useTranslation();
    const containerRef = useRef(null);

    //---- 音声ガイド　---
    const { playSound, stopSound, currentAudioSrc } = useAudio();   
    //一度再生された音声を記録（Refなので再描画でもリセットされない）
    const playedAudiosRef = useRef(new Set());

    const close = () => {
        stopSound();
        resetMarker();
    }
    const soundStart = () => {
        let src = "/assets/sound/" + row.sound;
        playSound(src , containerRef.current);
        playedAudiosRef.current.add(src); // 再生済みに記録
    };
    const soundStop = () => {
        stopSound();
    };
    const isPlayingSound = () => {
        return currentAudioSrc != "" 
    }

    useEffect(() => {
        if (!row || !row.sound) {
            stopSound();
            return;
        }

        // rowが変わったら前の音声を停止
        stopSound();
      
        //初めての再生ならば自動再生
        let src = "/assets/sound/" + row.sound;
        if (!playedAudiosRef.current.has(src)){
            soundStart();
        }

        // return でアンマウント時も停止
        return () => {
          stopSound();
        };
      }, [row]);

    if(row && row.name){
    return <>
    <Card className={"audioGuidCard mapCard"} sx={{
       position: 'absolute',
       bottom: '1%',
       right:'1%',
       width:'98%',
       zIndex:10000    
    }}>
    <Box className='head-content'>
        <Typography component="div" variant="h5" className="title">
            {row.name}
        </Typography>
        <IconButton className={"close"} size="large">
            <CloseIcon onClick={close} />
        </IconButton>
    </Box>

    <hr className={"hr95"} />
    <Box sx={{display:'flex'}}>
        <Box sx={{ display: 'block'}}>
            <CardContent className="card-content" sx={{ flex: '1 0 auto' }}>  
                <div className='btnWrap'>
                    {isPlayingSound(row)? (
                        <Button variant="contained" onClick={soundStop}>停止</Button>
                    ) : (
                        <Button variant="contained" onClick={soundStart}>音声ガイド</Button>
                    )}
                </div>
                <Box
                    ref={containerRef}
                    sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mt: 2, // ボタンとの余白
                    }}
                />
            </CardContent>
        </Box>
    </Box>
    </Card>       
    </>;
    }
});
export default MapCardAudioGuide
